(function () {
  'use strict';

  // Loaded by index.liquid only. Keep contextual tooltips and popovers untouched.
  if (!document.body.classList.contains('common-home')) return;

  var controls = [
    '#shopify-section-header .link-follow a',
    '#shopify-section-footer .link-follow a',
    '#shopify-section-header #wishlist-total',
    '#shopify-section-header #cart > button',
    '#shopify-section-header #cart .cart-close button',
    '#content .action-links .button',
    '#content .action-links .link-wishlist',
    '#content .owl-prev',
    '#content .owl-next',
    '#content .nivo-prevNav',
    '#content .nivo-nextNav',
    '#content .reputon-swiper-button-prev',
    '#content .reputon-swiper-button-next',
    '#shopify-section-footer #back-top',
    '#productModal .social-sharing a'
  ].join(',');

  function removeLabelPopup(control) {
    var title = control.getAttribute('title') || control.getAttribute('data-original-title');
    var tooltip = window.jQuery && window.jQuery(control).data('bs.tooltip');
    if (!title && control.getAttribute('data-toggle') !== 'tooltip' && !tooltip) return;

    // Save the translated name before Bootstrap's title attributes are removed.
    if (!control.getAttribute('aria-label') && !control.getAttribute('aria-labelledby')) {
      var name = title || control.textContent.trim();
      if (!name) return;
      control.setAttribute('aria-label', name);
    }

    if (tooltip) {
      tooltip.destroy();
    }
    control.removeAttribute('title');
    control.removeAttribute('data-original-title');
    // Quick view's modal and header dropdown triggers must remain functional.
    if (control.getAttribute('data-toggle') === 'tooltip') {
      control.removeAttribute('data-toggle');
    }
  }

  function clean(root) {
    if (root.nodeType === 1 && root.matches(controls)) removeLabelPopup(root);
    root.querySelectorAll(controls).forEach(removeLabelPopup);
  }

  // Run before the theme's ready callback initializes hover tooltips.
  clean(document);

  // Cover carousel clones, AJAX content and theme-editor section replacement.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) clean(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    clean(event.target);
  });
})();
